// The tenant is the subdomain: {tenant}.noxussoft.com. On localhost (dev) there is
// no tenant subdomain, so VITE_DEV_TENANT picks the tenant to preview.
const reservedSubdomains = ["app", "admin", "api", "www"];

export const getTenantSlug = () => {
  const host = window.location.hostname;

  if (host === "localhost" || host === "127.0.0.1") {
    return import.meta.env.VITE_DEV_TENANT ?? "demo-kebap";
  }

  // workers.dev preview has no tenant subdomain; allow ?tenant=slug for testing.
  if (host.endsWith(".workers.dev")) {
    return new URLSearchParams(window.location.search).get("tenant");
  }

  const subdomain = host.split(".")[0];

  if (!subdomain || reservedSubdomains.includes(subdomain)) {
    return null;
  }

  return subdomain;
};

// Arayüz metinleri buradan ÇIKTI: `pickLang(lang, tr, en, ar, ru)` konumsaldı ve beşinci bir dil
// eklemek her çağrıya yeni argüman demekti. Yerine anahtar tabanlı sözlük geldi (bkz. src/i18n).

// DB içeriği (ürün/kategori adı, ürün açıklaması): taban dil düz kolonda, diğerleri translations
// JSON'ında. Eksik dil ya da eksik alan tabana düşüyor.
//
// `lang` küçük harf dil kodu (Language.code ile aynı). Menü eskiden 'TR'/'EN' tutup burada
// toLowerCase()'liyordu; iki yazım tek biçime indi ve dönüştürme kalktı.
export const pickContent = (lang, row, field) => {
  if (!row) {
    return "";
  }

  return row.translations?.[lang]?.[field] || row[field];
};
